module.exports = __webpack_public_path__ + "img/mastercard.fb3c5d14.png";